export default "__VITE_ASSET__7b6b3c6d__"